import React from 'react';

import { AutocompleteOwnerState, AutocompleteRenderValueGetItemProps, autocompleteClasses, Chip } from '@mui/material';

// MUI's `limitTags` only collapses chips while the field is blurred, so a focused field still
// spills every chip past its edge. Capping the rendered chips holds the limit in both states.
export const limitChips = (chips: React.ReactNode[], max: number): React.ReactNode[] => {
  const hiddenCount = chips.length - max;
  if (hiddenCount <= 0) return chips;
  return [
    ...chips.slice(0, max),
    <span key="more" className={autocompleteClasses.tag}>
      +{hiddenCount}
    </span>,
  ];
};

export const renderLimitedChips =
  <T,>(labelOf: (option: T) => string, max: number) =>
  (
    selected: T[],
    getItemProps: AutocompleteRenderValueGetItemProps<true>,
    { size }: Pick<AutocompleteOwnerState<T, true, boolean, false>, 'size'>
  ): React.ReactNode[] =>
    limitChips(
      selected.map((option, index) => {
        const { key, ...itemProps } = getItemProps({ index });
        return <Chip key={key} label={labelOf(option)} size={size} {...itemProps} />;
      }),
      max
    );
